import api from '../services/api';

export async function fetchAuthenticatedBlobUrl(url: string): Promise<string> {
  const res = await api.get(url, { responseType: 'blob' });
  return URL.createObjectURL(res.data);
}

export async function openAuthenticatedBlob(url: string, mimeType?: string): Promise<void> {
  const res = await api.get(url, { responseType: 'blob' });
  const blob = mimeType ? new Blob([res.data], { type: mimeType }) : res.data;
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
}
